// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__25dbI","info":"Note_info__2CB7j","note":"Note_note__15iTt","actions":"Note_actions__2L1cb"};